import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';
import { P } from '../ui/typography';

interface JobConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  action: 'accept' | 'reject';
  jobTitle?: string;
  clientName?: string;
  venueName?: string;
  isMultiple?: boolean;
}

export function JobConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  action,
  jobTitle,
  clientName,
  venueName,
  isMultiple = false
}: JobConfirmationDialogProps) {
  const actionText = action === 'accept' ? 'Accept' : 'Decline';
  const actioningText = action === 'accept' ? 'accept' : 'decline';
  const multipleText = isMultiple ? ' all dates for' : '';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{actionText} Job{isMultiple ? ' (All Dates)' : ''}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to {actioningText}{multipleText} {jobTitle ? `"${jobTitle}"` : 'this job'}?
            {clientName && (
              <>
                {'\n\n'}
                <P className="font-semibold">Client: {clientName}</P>
              </>
            )}
            {venueName && (
              <>
                {'\n'}
                <P className="font-semibold">Venue: {venueName}</P>
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onPress={() => onOpenChange(false)}>
            <P className="text-gray-600">Cancel</P>
          </AlertDialogCancel>
          <AlertDialogAction
            className={action === 'accept' ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'}
            onPress={() => {
              onConfirm();
              onOpenChange(false);
            }}>
            <P className="text-white">{actionText}</P>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
